export default __webpack_public_path__ + "static/media/emoji-chat.201ffce9.svg";